import * as React from 'react';

import MentionCardHeaderYoutube from 'components/mention-card/mention-card-header/channels/youtube/MentionCardHeaderYoutube';
import MentionCardDetailsYoutube from 'components/mention-card/mention-card-details/channels/youtube/MentionCardDetailsYoutube';
import MentionCardInformationYoutube from 'components/mention-card/mention-card-information/channels/youtube/MentionCardInformationYoutube';

import './mention-card-youtube.scss';

import type { MentionCardModalItem, MentionCardViewType } from 'types';

type Props = {
  post: MentionCardModalItem,
  viewType: MentionCardViewType,
  children?: React.ReactNode,
  maxRowCount?: number,
  hideExternalLink?: boolean,
  hideAdditionalStatusLabel?: boolean
};

class MentionCardYoutube extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const {
      post,
      viewType,
      maxRowCount,
      children,
      hideExternalLink,
      hideAdditionalStatusLabel
    } = this.props;

    return (
      <div
        className="mention-card-youtube"
        data-qa="mention-card-youtube"
      >
        <MentionCardHeaderYoutube
          post={post}
          hideExternalLink={hideExternalLink}
        />
        <MentionCardDetailsYoutube
          post={post}
          viewType={viewType}
          hideAdditionalStatusLabel={hideAdditionalStatusLabel}
        >
          {children}
        </MentionCardDetailsYoutube>
        <MentionCardInformationYoutube
          post={post}
          maxRowCount={maxRowCount}
        />
      </div>
    );
  }
}

export default MentionCardYoutube;
